// Voeg hier je eigen custom JavaScript toe. Let op: Gebruik geen jQuery, maar vanilla JavaScript.

// On document ready:
document.addEventListener('DOMContentLoaded', function () {
    // Add your custom JavaScript here.
    // NOTE: This script will be loaded on every page AND in the Gutenberg editor.
    console.log('Page loaded!');

    document.querySelectorAll('a[href="#main"]').forEach(link => {
        link.addEventListener("click", function(e) {
            e.preventDefault();
            const target = document.querySelector("main"); // eerste element met class .main
            if (target) {
            target.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
            }
        });
    });

const toggleBtn = document.querySelector(".toggle-menu");
const links = document.querySelectorAll(".link-extern-website");

toggleBtn.addEventListener("click", function () {
  links.forEach(link => link.classList.toggle("active"));
});
});